import React from "react";
// import Img from "gatsby-image";

import { GatsbyImage } from "gatsby-plugin-image";

const Image = ({
  imageSrc,
  altText,
  cssClassName = "coop-c-editorialcard__image",
}) => {
  return (
    <GatsbyImage image={imageSrc} alt={altText} className={cssClassName} />
  );
};

export default Image;
